

export interface RunePathMappings {
  [key: string]: string;
}

export const runePathMappings: RunePathMappings = {
  //Precision
  'Conqueror': 'Styles/Precision/Conqueror/Conqueror.png',
  'Coup de Grace': 'Styles/Precision/CoupDeGrace/CoupDeGrace.png',
  'Cut Down': 'Styles/Precision/CutDown/CutDown.png',
  'Fleet Footwork': 'Styles/Precision/FleetFootwork/FleetFootwork.png',
  'Legend: Alacrity': 'Styles/Precision/LegendAlacrity/LegendAlacrity.png',
  'Legend: Bloodline': 'Styles/Precision/LegendBloodline/LegendBloodline.png',
  'Legend: Tenacity': 'Styles/Precision/LegendTenacity/LegendTenacity.png',
  'Legend: Haste': 'Styles/Precision/LegendHaste/LegendHaste.png',
  'Lethal Tempo': 'Styles/Precision/LethalTempo/LethalTempoTemp.png',
  'Presence of Mind': 'Styles/Precision/PresenceOfMind/PresenceOfMind.png',
  'Press the Attack': 'Styles/Precision/PressTheAttack/PressTheAttack.png',
  'Absorb Life': 'Styles/Precision/AbsorbLife/AbsorbLife.png',
  'Overheal': 'Styles/Precision/Overheal.png',
  'Triumph': 'Styles/Precision/Triumph.png',
  
  
  //Domination
  'Cheap Shot': 'Styles/Domination/CheapShot/CheapShot.png',
  'Dark Harvest': 'Styles/Domination/DarkHarvest/DarkHarvest.png',
  'Electrocute': 'Styles/Domination/Electrocute/Electrocute.png',
  'Eyeball Collection': 'Styles/Domination/EyeballCollection/EyeballCollection.png',
  'Ghost Poro': 'Styles/Domination/GhostPoro/GhostPoro.png',
  'Hail of Blades': 'Styles/Domination/HailOfBlades/HailOfBlades.png',
  'Ingenious Hunter': 'Styles/Domination/IngeniousHunter/IngeniousHunter.png',
  'Predator': 'Styles/Domination/Predator/Predator.png',
  'Ravenous Hunter': 'Styles/Domination/RavenousHunter/RavenousHunter.png',
  'Relentless Hunter': 'Styles/Domination/RelentlessHunter/RelentlessHunter.png',
  'Sudden Impact': 'Styles/Domination/SuddenImpact/SuddenImpact.png',
  'Taste of Blood': 'Styles/Domination/TasteOfBlood/GreenTerror_TasteOfBlood.png',
  'Treasure Hunter': 'Styles/Domination/TreasureHunter/TreasureHunter.png',
  'Ultimate Hunter': 'Styles/Domination/UltimateHunter/UltimateHunter.png',
  'Zombie Ward': 'Styles/Domination/ZombieWard/ZombieWard.png',

  //Sorcery
  // ...other rune mappings
'Celerity': 'Styles/Sorcery/Celerity/CelerityTemp.png',
'Nimbus Cloak': 'Styles/Sorcery/NimbusCloak/6361.png',
'Nullifying Orb': 'Styles/Sorcery/NullifyingOrb/Pokeshield.png',
'Absolute Focus': 'Styles/Sorcery/AbsoluteFocus/AbsoluteFocus.png',
'Arcane Comet': 'Styles/Sorcery/ArcaneComet/ArcaneComet.png',
'Gathering Storm': 'Styles/Sorcery/GatheringStorm/GatheringStorm.png',
'Last Stand': 'Styles/Sorcery/LastStand/LastStand.png',
'Manaflow Band': 'Styles/Sorcery/ManaflowBand/ManaflowBand.png',
'Phase Rush': 'Styles/Sorcery/PhaseRush/PhaseRush.png',
'Scorch': 'Styles/Sorcery/Scorch/Scorch.png',
'Summon Aery': 'Styles/Sorcery/SummonAery/SummonAery.png',
'Transcendence': 'Styles/Sorcery/Transcendence/Transcendence.png',
'Unflinching': 'Styles/Sorcery/Unflinching/Unflinching.png',
'Waterwalking': 'Styles/Sorcery/Waterwalking/Waterwalking.png',

  //Inspiration
'Biscuit Delivery': 'Styles/Inspiration/BiscuitDelivery/BiscuitDelivery.png',
'Celestial Body': 'Styles/Inspiration/CelestialBody/CelestialBody.png',
'Cosmic Insight': 'Styles/Inspiration/CosmicInsight/CosmicInsight.png',
'First Strike': 'Styles/Inspiration/FirstStrike/FirstStrike.png',
'Cash Back': 'Styles/Inspiration/CashBack/CashBack.png',
'Jack of All Trades': 'Styles/Inspiration/JackOfAllTrades/JackOfAllTrades.png',
'Futures Market': 'Styles/Inspiration/FuturesMarket/FuturesMarket.png',
'Glacial Augment': 'Styles/Inspiration/GlacialAugment/GlacialAugment.png',
'Hextech Flashtraption': 'Styles/Inspiration/HextechFlashtraption/HextechFlashtraption.png',
'Kleptomancy': 'Styles/Inspiration/Kleptomancy/Kleptomancy.png',
'Magical Footwear': 'Styles/Inspiration/MagicalFootwear/MagicalFootwear.png',
'Minion Dematerializer': 'Styles/Inspiration/MinionDematerializer/MinionDematerializer.png',
'Perfect Timing': 'Styles/Inspiration/PerfectTiming/PerfectTiming.png',
'Time Warp Tonic': 'Styles/Inspiration/TimeWarpTonic/TimeWarpTonic.png',
'Unsealed Spellbook': 'Styles/Inspiration/UnsealedSpellbook/UnsealedSpellbook.png',

  //Resolve
'Approach Velocity': 'Styles/Resolve/ApproachVelocity/ApproachVelocity.png',
'Bone Plating': 'Styles/Resolve/BonePlating/BonePlating.png',
'Chrysalis': 'Styles/Resolve/Chrysalis/Chrysalis.png',
'Conditioning': 'Styles/Resolve/Conditioning/Conditioning.png',
'Demolish': 'Styles/Resolve/Demolish/Demolish.png',
'Font of Life': 'Styles/Resolve/FontOfLife/FontOfLife.png',
'Grasp of the Undying': 'Styles/Resolve/GraspOfTheUndying/GraspOfTheUndying.png',
'Guardian': 'Styles/Resolve/Guardian/Guardian.png',
'Iron Skin': 'Styles/Resolve/IronSkin/IronSkin.png',
'Mirror Shell': 'Styles/Resolve/MirrorShell/MirrorShell.png',
'Overgrowth': 'Styles/Resolve/Overgrowth/Overgrowth.png',
'Revitalize': 'Styles/Resolve/Revitalize/Revitalize.png',
'Second Wind': 'Styles/Resolve/SecondWind/SecondWind.png',
'Aftershock': 'Styles/Resolve/VeteranAftershock/VeteranAftershock.png',
};

  
  
export const SHARD_ICON_PATHS = {
  'Adaptive Force': 'https://raw.communitydragon.org/pbe/plugins/rcp-be-lol-game-data/global/default/v1/perk-images/statmods/statmodsadaptiveforceicon.png',
  'Attack Speed': 'https://raw.communitydragon.org/pbe/plugins/rcp-be-lol-game-data/global/default/v1/perk-images/statmods/statmodsattackspeedicon.png',
  'Ability Haste': 'https://raw.communitydragon.org/pbe/plugins/rcp-be-lol-game-data/global/default/v1/perk-images/statmods/statmodscdrscalingicon.png',
  'Bonus Movement Speed': 'https://raw.communitydragon.org/pbe/plugins/rcp-be-lol-game-data/global/default/v1/perk-images/statmods/statmodsmovementspeedicon.png',
  'Scaling Bonus Health':  'https://raw.communitydragon.org/pbe/plugins/rcp-be-lol-game-data/global/default/v1/perk-images/statmods/statmodshealthplusicon.png',
  'Bonus Health': 'https://raw.communitydragon.org/pbe/plugins/rcp-be-lol-game-data/global/default/v1/perk-images/statmods/statmodshealthscalingicon.png',
  'Tenacity and Slow Resist': 'https://raw.communitydragon.org/pbe/plugins/rcp-be-lol-game-data/global/default/v1/perk-images/statmods/statmodstenacityicon.png',
  // ... add other mappings
 

};

export default SHARD_ICON_PATHS;
